import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { fadeInAnimation } from "../../animations/fadeInAnimation";
import { PureOriginalUserModel } from "../../models/PureOriginalUser-model";
import { PureOriginalService } from "../../service/pure-original.service";



@Component({
    selector: 'app-pure-original-details',
    templateUrl: './pure-original-details.component.html',
    styleUrls: ['./pure-original-details.component.css'],
    animations: [fadeInAnimation],
    host: { '[@fadeInAnimation]': '' }
})
export class PureOriginalDetailsComponent {

    public pureOriginalId = signal<number>(-1);
    public pureOriginalMatchingIds = signal<number[]>([]);
    public from = signal<number>(-1);
    public to = signal<number>(-1);
    public pureOriginalUser = signal<PureOriginalUserModel | null>(null);

    public isFileModalOpened = signal<boolean>(false);
    public versionName = signal<string>('');
    public isImpossibleTuningUploaded = signal<boolean>(false);

    public disabled = signal<boolean>(false);


    router = inject(Router);
    route = inject(ActivatedRoute);
    pureOriginalService = inject(PureOriginalService);

    constructor() {
        this.route.queryParams
            .pipe(takeUntilDestroyed())
            .subscribe(params => {
            this.pureOriginalId.set(params['pureOriginalId'])

            // Handle matching IDs (comma-separated string)
            const matchingIds: number[] = [];
            if (params["matchingIds"]) {
                const idsString = params["matchingIds"];
                const ids = idsString.split(',').map(id => +id.trim()).filter(id => !isNaN(id));
                matchingIds.push(...ids);
            }

            this.pureOriginalMatchingIds.set(matchingIds);
        })
    }


    backToMainTable() {
        this.pureOriginalService.triggerBackFunction();
    }

    openFileModal($event: any) {
        this.isFileModalOpened.set($event.valueOf());
    }

    getVersionName($event: any) {
        this.versionName.set($event.valueOf());
    }

    closeModal($event: any) {
        this.isFileModalOpened.set($event.valueOf());
        this.versionName.set(null);
    }


    getPureOriginalUser($event: any) {
        this.pureOriginalUser.set($event.valueOf());
    }

    getDisabledButton($event: any) {
        this.disabled.set($event.valueOf());
    }

}
